module.exports = __webpack_public_path__ + "static/media/main-background.f71f8bcb.mp3";